
import Vue from 'vue';
import VueMarkdown from '@adapttive/vue-markdown';
import katex from '@iktakahiro/markdown-it-katex';
import { ImageModel } from '@descomplica/dex-models';

interface Data {
  plugins: any;
  showZoomImage: boolean;
}

export default Vue.extend({
  components: {
    VueMarkdown,
  },
  props: {
    content: {
      type: ImageModel,
      required: true,
    },
  },
  data(): Data {
    return {
      plugins: [
        {
          plugin: katex,
          options: { throwOnError: false },
        },
      ],
      showZoomImage: false,
    };
  },
  methods: {
    clickHandler(): void {
      this.toggleZoom();
    },
    toggleZoom(): void {
      this.showZoomImage = !this.showZoomImage;
    },
  },
});
